import { ComponentProps } from "react";
import * as S from "./styles";
import { maskMoney } from "../../../utils/masks";

interface IMonetaryBadgeMarginProps extends ComponentProps<"div"> {
  margem: number;
  percentualMargem: number;
}

export const MonetaryBadgeMargin = ({
  margem,
  percentualMargem,
  ...rest
}: IMonetaryBadgeMarginProps) => {
  const isPositive = margem >= 0;

  const pathIcon = isPositive
    ? "/assets/svgs/icon-chart-positive.svg"
    : "/assets/svgs/icon-chart-negative.svg";

  return (
    <S.Container positive={isPositive} {...rest}>
      <S.WrapperImg>
        <img src={pathIcon} alt="chart" />
        <p>% {percentualMargem}</p>
      </S.WrapperImg>

      <p>
        Margem Líquida: <span> {maskMoney(margem)}</span>
      </p>
    </S.Container>
  );
};
